module.exports = __webpack_public_path__ + "static/media/slide-2.3714e74c.jpg";